.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.fileInput {
  display: none;
}
